import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SidebarLayout from "./Layout/SidebarLayout";
import Authenticated from "./Guard/Authenticated";
import Guest from "./Guard/Guest";
import BaseLayout from "./Layout/BaseLayout";
import LoadScreen from "./Component/loaderScreen";

export function RenderRout() {
  
  return (
    <>
      <Router>
     
        <Suspense fallback={<LoadScreen />}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  // Auth Pages

  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/",
    element: lazy(() => import("./Component/Pages/Auth/Login")),
  },

  // forget password

  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/forget-password",
    element: lazy(() =>
      import("./Component/Pages/forget-password/ForgetPassword")
    ),
  },
  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/reset-password",
    element: lazy(() =>
      import("./Component/Pages/forget-password/ResetPassword")
    ),
  },

  //chnage password
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/chnage-password",
    element: lazy(() => import("./Component/Pages/Auth/UpdatePassword")),
  },

  //Update Profile
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/update-profile",
    element: lazy(() => import("./Component/Pages/Auth/UpdateProfile")),
  },

  //Dashboard Pages
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/dashboard",
    element: lazy(() => import("./Component/Pages/Dasboards/Index")),
  },

  //empolyee Pages
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/empolyee",
    element: lazy(() => import("./Component/Pages/Empolyee/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/department",
    element: lazy(() => import("./Component/Pages/Technology/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/technology",
    element: lazy(() => import("./Component/Pages/Technology/Technilogylist")),
  },
  //client
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/client",
    element: lazy(() => import("./Component/Pages/Client/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/projects/:type?",
    element: lazy(() => import("./Component/Pages/Projects/Index")),
  },
{
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/stats",
    element: lazy(() => import("./Component/Pages/ProjectStats/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/projects/view/:id",
    element: lazy(() => import("./Component/Pages/Projects/ProjectsDetiels")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/task",
    element: lazy(() => import("./Component/Pages/Task/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/task/complete/:id?",
    element: lazy(() => import("./Component/Pages/Task/Complatedtask")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/estimation",
    element: lazy(() => import("./Component/Pages/Estimations/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/activitylog",
    element: lazy(() => import("./Component/Pages/ActivityLog/Index")),
  },

  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/notification",
    element: lazy(() => import("./Component/Pages/Notification/Index")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/count",
    element: lazy(() => import("./Component/Pages/EmployeeTaskListing/Index")),
  },
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/count/task",
    element: lazy(() => import("./Component/Pages/EmployeeTaskListing/ReportingTask")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/hourly-report",
    element: lazy(() => import("./Component/Pages/EmployeeTaskListing/ReportingTask")),
  },
     {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/financial-report",
    element: lazy(() => import("./Component/Pages/Reports/FinecialReport")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/support",
    element: lazy(() => import("./Component/Pages/Support/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/note",
    element: lazy(() => import("./Component/Pages/Notes/Index")),
  },

     {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/hr-projects",
    element: lazy(() => import("./Component/Pages/Hr/Projects/ProjectList")),
  },
     {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/hr-projects/view/:id",
    element: lazy(() => import("./Component/Pages/Hr/Projects/ViewProject")),
  },
   {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/hr-task",
    element: lazy(() => import("./Component/Pages/Hr/Task/Index")),
  },
    {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/hr-leave",
    element: lazy(() => import("./Component/Pages/Hr/Leave/Index")),
  },
  ///404 Page

  {
    layout: BaseLayout,
    exact: true,
    path: "*",
    element: lazy(() => import("./Component/PageNotFound")),
  },
];
